import { motion } from 'motion/react';

import type { Severity } from '@smartapply/shared';

interface HighlightExcerptProps {
  text: string;
  severity: Severity;
  delay?: number;
}

/**
 * Signature: trecho citado do perfil com fundo "marca-texto" (saffron pra
 * sugestão, crimson pra crítico, forest pra força positiva). Animação de
 * "highlight pass" — o fundo entra da esquerda pra direita simulando alguém
 * passando o marca-texto.
 */
export function HighlightExcerpt({ text, severity, delay = 0 }: HighlightExcerptProps) {
  const palette = paletteOf(severity);

  return (
    <span className="relative inline">
      <motion.span
        aria-hidden
        className="absolute inset-0 -z-0"
        style={{ backgroundColor: palette.bg }}
        initial={{ scaleX: 0, originX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay, duration: 0.35, ease: 'easeOut' }}
      />
      <span
        className="relative z-10 font-mono text-[0.95em]"
        style={{ color: palette.fg, paddingInline: '0.2em' }}
      >
        {text}
      </span>
    </span>
  );
}

function paletteOf(severity: Severity) {
  switch (severity) {
    case 'critical':
      return {
        bg: 'var(--accent-crimson-bg)',
        fg: 'var(--accent-crimson)',
      };
    case 'suggestion':
      return {
        bg: 'var(--accent-saffron-bg)',
        fg: 'var(--ink-primary)',
      };
    case 'positive':
      return {
        bg: 'var(--accent-forest-bg)',
        fg: 'var(--accent-forest)',
      };
  }
}
